<template>
  <div>
    <v-flex xs12 class="mb-3">
      <h2 class="text-center mb-3">Generelt</h2>
    </v-flex>
    <v-alert
      v-if="protocol.related_protocol"
      :value="true"
      color="success"
      type="success"
    >
      Skjemaet er ferdig utfylt med info innflyttingsprotokoll
    </v-alert>
    <v-flex xs12 class="mb-2 mt-3">
      <general-input-table
        objectTitle="Område"
        commentTitle="Kommentar"
        v-model="stepValues.areaList"
        @update-fields="updateFields"
      ></general-input-table>
    </v-flex>
    <v-flex xs12 v-if="config.info">
      <i v-html="config.info" />
    </v-flex>
    <v-divider></v-divider>
    <v-flex xs12 class="mb-3">
      <v-textarea
        box
        label="Andre kommentarer"
        v-model="stepValues.comment"
        @input="updateFields"
      ></v-textarea>
    </v-flex>
    <StepButtons @next-page="next" @previous-page="previous" :step="this" />
  </div>
</template>

<script>
import GeneralInputTable from "../form/GeneralInputTable.vue";
import step from "../../mixins/step";
export default {
  mixins: [step],
  components: { GeneralInputTable },
  mounted: function () {
    if (this.protocol.related_protocol && this.stepValues) {
      if (
        this.stepValues.loadedFromRelated == null ||
        this.stepValues.loadedFromRelated == undefined
      ) {
        if (this.protocol.related_protocol.steps.generaladvanced) {
          if (
            this.protocol.related_protocol.steps.generaladvanced.saved_values
              .areaList
          ) {
            this.stepValues.loadedFromRelated = true;
            let areaList = JSON.parse(
              JSON.stringify(
                this.protocol.related_protocol.steps.generaladvanced.saved_values.areaList
              )
            );
            this.stepValues.areaList = areaList;
          }
        }
      }
    }
  },
};
</script>
